import React from 'react';

// Types
import { FeedbackRecognitionType } from 'Shared/constants/types';

// Components
import KudoItem from 'Shared/components/KudoItem/KudoItem';

// Styles
import './KudosContainer.scss';

type Props = {
  kudos: Array<FeedbackRecognitionType>;
};

const KudosContainer = ({ kudos }: Props) => {
  const baseClassName = 'KudosContainer';
  return (
    <div className={baseClassName}>
      {kudos.map(kudo => (
        <KudoItem key={kudo.uuid} feedback={kudo} />
      ))}
    </div>
  );
};

export default KudosContainer;
